// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex, { mapGetters } from 'vuex'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import store from './store'
import moment from 'moment'
import VueAnalytics from 'vue-analytics'

require('./assets/stylus/main.styl')

Vue.use(Vuex)
Vue.use(Vuetify)
Vue.use(VueAnalytics, {
  id: 'UA-78537321-3',
  router,
  autoTracking: {
    pageviewOnLoad: true
  }
})

Vue.mixin({
  computed: {
    ...mapGetters([
      'isLoading',
      'errorMessage',
      'authorized'
    ])
  },
  methods: {
    fromNow: (time) => {
      moment.locale('zh-tw')
      return moment(time).endOf('hour').fromNow()
    }
  }
})

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // console.log(router.app.$store)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!router.app.$store.getters.authorized) {
      next({
        path: '/login'
        // query: { redirect: to.fullPath }
      })
    } else {
      // already login
      next()
    }
  } else {
    next()
    // if (to.path === '/' && router.app.$store.getters.authorized) {
    //   next({ path: '/' })
    // } else {
    //   next()
    // }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js